module.exports = __webpack_public_path__ + "main/assets/public/player-controls/mute-icon.aafd143796956770.svg";